const CHALLENGE_TTL_MS = 5 * 60 * 1000;

export interface PendingMfaChallenge {
  email: string;
  password: string;
  mfaToken: string;
  expiresAt: number;
}

let pending: PendingMfaChallenge | null = null;
let expiryTimer: ReturnType<typeof setTimeout> | null = null;
let beforeUnloadRegistered = false;

function clearExpiryTimer(): void {
  if (expiryTimer) {
    clearTimeout(expiryTimer);
    expiryTimer = null;
  }
}

function scheduleExpiry(): void {
  clearExpiryTimer();
  if (!pending) return;
  const ms = Math.max(0, pending.expiresAt - Date.now());
  expiryTimer = setTimeout(() => {
    clearPendingMfaChallenge();
  }, ms);
}

function ensureBeforeUnload(): void {
  if (beforeUnloadRegistered || typeof window === 'undefined') return;
  window.addEventListener('beforeunload', clearPendingMfaChallenge);
  beforeUnloadRegistered = true;
}

export function setPendingMfaChallenge(input: {
  email: string;
  password: string;
  mfaToken: string;
}): void {
  pending = {
    email: input.email,
    password: input.password,
    mfaToken: input.mfaToken,
    expiresAt: Date.now() + CHALLENGE_TTL_MS,
  };
  ensureBeforeUnload();
  scheduleExpiry();
}

export function getPendingMfaChallenge(): PendingMfaChallenge | null {
  if (!pending) return null;
  if (Date.now() >= pending.expiresAt) {
    clearPendingMfaChallenge();
    return null;
  }
  return pending;
}

export function clearPendingMfaChallenge(): void {
  pending = null;
  clearExpiryTimer();
}

export function getPendingMfaChallengeRemainingMs(): number {
  if (!pending) return 0;
  return Math.max(0, pending.expiresAt - Date.now());
}
